import React from 'react';
import { resolveAttendanceStatus, STATUS_PALETTE, todayIsoLocal } from '@/lib/attendanceStatus';

export default function AttendanceStatusBadge({
  source,
  status,
  size = 'md',
  testId,
  className = '',
  palette = STATUS_PALETTE,
}) {
  const resolved = status || resolveAttendanceStatus({ today: todayIsoLocal(), ...source });
  if (!resolved) return null;
  const pal = palette[resolved.code] || palette.offen || STATUS_PALETTE.offen;
  const box = size === 'sm' ? 'w-6 h-6 text-[10px]' : 'w-8 h-8 text-xs';
  return (
    <span
      data-testid={testId}
      title={resolved.title}
      aria-label={resolved.title}
      className={`inline-flex items-center justify-center font-bold rounded border shrink-0 ${box} ${className}`}
      style={{ background: pal.bg, color: pal.fg, borderColor: pal.border }}
    >
      {resolved.short}
    </span>
  );
}
